exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grecaptcha-badge {\n  visibility: hidden !important;\n}\ninput[type=file].form-control {\n  background: none;\n  border: none;\n  box-shadow: none;\n}\nlegend {\n  color: #C53645;\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n.form-group.required > label:after {\n  color: #C53645;\n}\nbutton:disabled:hover {\n  background: #004A86;\n  border-color: #004A86;\n}\n.email-disclaimer {\n  font-size: 12px;\n  font-style: italic;\n}", ""]);

// exports
